import { AgrLoginTypes, IETFLocales, SignupSigninPolicy } from '@next/core-lib/environment';

import { Environment } from './environment.model';
export { Environment } from './environment.model';

export const environment: Environment = {
  APPLICATION_NAME: 'Mestplace',
  CLIENT_ID: '8c830f86-9b7a-4d6b-a6bb-140b5ffcbd9b',
  REDIRECT_URL: 'https://mestplace.agrifirm.com',
  LOGIN_TYPE: AgrLoginTypes.redirect,
  SIGNUP_SIGNIN_POLICY: SignupSigninPolicy.All,
  PASSWORD_RESET_POLICY: 'B2C_1A_PasswordReset',
  AUTHORITY: 'https://agrifirmb2c.b2clogin.com/tfp/agrifirmb2c.onmicrosoft.com/',
  AUTHORIZED_BY: {},
  APP_INSIGHTS_KEY: '85cd43e7-c453-4fae-af0f-f11c73380889',
  API_BASE_URL: 'https://mestplace.agrifirm.com',
  APPLICATION_KEY: 'Mestplace',
  DEFAULT_LOCALE: IETFLocales.nl,
  APIM_BASE_URL: 'https://gateway.api.agrifirm.com/external',
  RELATIONSHIPS_ELASTIC_SEARCH: true,
  PRODUCTION: true,
  KUBE_NODE_NAME: 'local-node',
  KUBE_POD_NAME: 'local-pod',
  KUBE_TEAM: 'platform',
  LOCALES: [IETFLocales.nl, IETFLocales.en],
  SHOP_URL: '',
  MSAL_LOGGING: false,
  NGRX_LOGGING: false,
  ERROR_PAGE_HOME_BUTTON: false,
  ERROR_PAGE_BACK_BUTTON: false,
  DELIVERY_TIME_WINDOW_DISABLED: false,
  SHOW_CART_ICON: false,
  SHOW_DISABLED_LOCATION_BADGE: false,
  SUBSCRIBE_TO_CART_EVENTS: false,
  IS_MY_PROSPECTS_HIDDEN: false,
  ARE_ORDER_BLOCKED_LOCATIONS_HIDDEN: false,
};
